"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IrcClient = void 0;
var tslib_1 = require("tslib");
var connection_1 = require("@d-fischer/connection");
var logger_1 = require("@d-fischer/logger");
var shared_utils_1 = require("@d-fischer/shared-utils");
var typed_event_emitter_1 = require("@d-fischer/typed-event-emitter");
var json_1 = require("klona/json");
var CoreCapabilities = require("./Capability/CoreCapabilities");
var Message_1 = require("./Message/Message");
var MessageCollector_1 = require("./Message/MessageCollector");
var MessageParser_1 = require("./Message/MessageParser");
var MessageTypes = require("./Message/MessageTypes");
var Commands_1 = require("./Message/MessageTypes/Commands");
var Numerics_1 = require("./Message/MessageTypes/Numerics");
var ServerProperties_1 = require("./ServerProperties");
var StringTools_1 = require("./Toolkit/StringTools");
var IrcClient = /** @class */ (function (_super) {
    tslib_1.__extends(IrcClient, _super);
    function IrcClient(options) {
        var e_1, _a;
        var _this = _super.call(this) || this;
        _this._registered = false;
        _this._supportsCapabilities = true;
        _this._events = new Map();
        _this._registeredMessageTypes = new Map();
        /**
         * @eventListener
         */
        _this.onConnect = _this.registerEvent();
        /**
         * @eventListener
         */
        _this.onRegister = _this.registerEvent();
        /**
         * @eventListener
         */
        _this.onDisconnect = _this.registerEvent();
        /**
         * @eventListener
         */
        _this.onPrivmsg = _this.registerEvent();
        /**
         * @eventListener
         */
        _this.onAction = _this.registerEvent();
        /**
         * @eventListener
         */
        _this.onNotice = _this.registerEvent();
        /**
         * @eventListener
         */
        _this.onNickChange = _this.registerEvent();
        /**
         * @eventListener
         */
        _this.onCtcp = _this.registerEvent();
        /**
         * @eventListener
         */
        _this.onCtcpReply = _this.registerEvent();
        /**
         * @eventListener
         */
        _this.onPasswordError = _this.registerEvent();
        /**
         * @eventListener
         */
        _this.onAnyMessage = _this.registerEvent();
        _this._serverProperties = json_1.klona(ServerProperties_1.defaultServerProperties);
        _this._supportedFeatures = {};
        _this._collectors = [];
        _this._clientCapabilities = new Map();
        _this._serverCapabilities = new Map();
        _this._negotiatedCapabilities = new Map();
        _this._initialConnectionSetupDone = false;
        var connection = options.connection, credentials = options.credentials, channels = options.channels, channelTypes = options.channelTypes, webSocket = options.webSocket, _b = options.logger, logger = _b === void 0 ? {} : _b;
        _this._options = options;
        var _c = connection.pingOnInactivity, pingOnInactivity = _c === void 0 ? 60 : _c, _d = connection.pingTimeout, pingTimeout = _d === void 0 ? 10 : _d;
        _this._pingOnInactivity = pingOnInactivity;
        _this._pingTimeout = pingTimeout;
        _this._currentNick = credentials.nick;
        _this._logger = logger_1.createLogger(tslib_1.__assign({ name: 'ircv3', emoji: true }, logger));
        _this.registerCoreMessageTypes();
        var hostName = connection.hostName, secure = connection.secure, _e = connection.reconnect, reconnect = _e === void 0 ? true : _e;
        var connectionOptions = {
            hostName: hostName,
            port: _this.port,
            secure: secure,
            lineBased: true
        };
        var ConnectionType = webSocket ? connection_1.WebSocketConnection : connection_1.DirectConnection;
        if (reconnect) {
            _this._connection = new connection_1.PersistentConnection(ConnectionType, connectionOptions, { logger: _this._logger }, options.connectionOptions);
        }
        else {
            _this._connection = new ConnectionType(connectionOptions, _this._logger, options.connectionOptions);
        }
        try {
            for (var _f = tslib_1.__values(Object.values(CoreCapabilities)), _g = _f.next(); !_g.done; _g = _f.next()) {
                var cap = _g.value;
                _this.addCapability(cap);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (channels) {
            _this.addInternalListener(_this.onRegister, function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var resolvedChannels, resolvedChannels_1, resolvedChannels_1_1, channel;
                var e_2, _a;
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, shared_utils_1.resolveConfigValue(channels)];
                        case 1:
                            resolvedChannels = _b.sent();
                            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                            if (resolvedChannels) {
                                try {
                                    for (resolvedChannels_1 = tslib_1.__values(resolvedChannels), resolvedChannels_1_1 = resolvedChannels_1.next(); !resolvedChannels_1_1.done; resolvedChannels_1_1 = resolvedChannels_1.next()) {
                                        channel = resolvedChannels_1_1.value;
                                        this.join(channel);
                                    }
                                }
                                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                finally {
                                    try {
                                        if (resolvedChannels_1_1 && !resolvedChannels_1_1.done && (_a = resolvedChannels_1.return)) _a.call(resolvedChannels_1);
                                    }
                                    finally { if (e_2) throw e_2.error; }
                                }
                            }
                            return [2 /*return*/];
                    }
                });
            }); });
        }
        _this.onTypedMessage(Commands_1.CapabilityNegotiation, function (_a) {
            var _b = _a.params, subCommand = _b.subCommand, capabilities = _b.capabilities;
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var caps, _c, capList, _d, _e, _f, name, cap, capNames_1, caps_1, caps_1_1, cap;
                var e_3, _g, e_4, _h;
                return tslib_1.__generator(this, function (_j) {
                    switch (_j.label) {
                        case 0:
                            caps = capabilities.split(' ');
                            _c = subCommand.toUpperCase();
                            switch (_c) {
                                case 'NEW': return [3 /*break*/, 1];
                                case 'DEL': return [3 /*break*/, 3];
                            }
                            return [3 /*break*/, 4];
                        case 1:
                            this._logger.debug("Server registered new capabilities: " + caps.join(', '));
                            capList = shared_utils_1.arrayToObject(caps, function (part) {
                                var _a;
                                if (!part) {
                                    return {};
                                }
                                var _b = tslib_1.__read(shared_utils_1.splitWithLimit(part, '=', 2), 2), cap = _b[0], param = _b[1];
                                return _a = {},
                                    _a[cap] = {
                                        name: cap,
                                        param: param || true
                                    },
                                    _a;
                            });
                            try {
                                for (_d = tslib_1.__values(Object.entries(capList)), _e = _d.next(); !_e.done; _e = _d.next()) {
                                    _f = tslib_1.__read(_e.value, 2), name = _f[0], cap = _f[1];
                                    this._serverCapabilities.set(name, cap);
                                }
                            }
                            catch (e_3_1) { e_3 = { error: e_3_1 }; }
                            finally {
                                try {
                                    if (_e && !_e.done && (_g = _d.return)) _g.call(_d);
                                }
                                finally { if (e_3) throw e_3.error; }
                            }
                            capNames_1 = Object.keys(capList);
                            return [4 /*yield*/, this._negotiateCapabilities(Array.from(this._clientCapabilities.entries())
                                    .filter(function (_a) {
                                    var _b = tslib_1.__read(_a, 1), name = _b[0];
                                    return capNames_1.includes(name);
                                })
                                    .map(function (_a) {
                                    var _b = tslib_1.__read(_a, 2), cap = _b[1];
                                    return cap;
                                }))];
                        case 2:
                            _j.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            {
                                this._logger.debug("Server removed capabilities: " + caps.join(', '));
                                try {
                                    for (caps_1 = tslib_1.__values(caps), caps_1_1 = caps_1.next(); !caps_1_1.done; caps_1_1 = caps_1.next()) {
                                        cap = caps_1_1.value;
                                        this._serverCapabilities.delete(cap);
                                        this._negotiatedCapabilities.delete(cap);
                                    }
                                }
                                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                                finally {
                                    try {
                                        if (caps_1_1 && !caps_1_1.done && (_h = caps_1.return)) _h.call(caps_1);
                                    }
                                    finally { if (e_4) throw e_4.error; }
                                }
                            }
                            _j.label = 4;
                        case 4: return [2 /*return*/];
                    }
                });
            });
        });
        _this.onTypedMessage(Commands_1.Ping, function (_a) {
            var message = _a.params.message;
            _this.sendMessage(Commands_1.Pong, { message: message });
        });
        _this.onTypedMessage(Numerics_1.Reply001Welcome, function (_a) {
            var me = _a.params.me;
            return _this._handleReceivedClientNick(me);
        });
        _this.onTypedMessage(Numerics_1.Reply004ServerInfo, function (_a) {
            var userModes = _a.params.userModes;
            if (userModes) {
                _this._serverProperties.supportedUserModes = userModes;
            }
        });
        _this.onTypedMessage(Numerics_1.Reply005Isupport, function (_a) {
            var supports = _a.params.supports;
            var newFeatures = shared_utils_1.arrayToObject(supports.split(' '), function (part) {
                var _a;
                var _b = tslib_1.__read(shared_utils_1.splitWithLimit(part, '=', 2), 2), support = _b[0], param = _b[1];
                return _a = {}, _a[support] = param || true, _a;
            });
            _this._supportedFeatures = tslib_1.__assign(tslib_1.__assign({}, _this._supportedFeatures), newFeatures);
        });
        _this.onTypedMessage(Numerics_1.Reply376EndOfMotd, function (_a) {
            var me = _a.params.me;
            if (!_this._registered) {
                _this._handleReceivedClientNick(me);
                _this._registered = true;
                _this.emit(_this.onRegister);
            }
        });
        _this.onTypedMessage(Numerics_1.Error422NoMotd, function (_a) {
            var me = _a.params.me;
            if (!_this._registered) {
                _this._handleReceivedClientNick(me);
                _this._registered = true;
                _this.emit(_this.onRegister);
            }
        });
        _this.onTypedMessage(Numerics_1.Error462AlreadyRegistered, function (_a) {
            var me = _a.params.me;
            // what, I thought we are not registered yet?
            if (!_this._registered) {
                // screw this, we are now.
                _this._logger.warn("We thought we're not registered yet, but we actually are");
                _this._handleReceivedClientNick(me);
                _this._registered = true;
                _this.emit(_this.onRegister);
            }
        });
        _this.onTypedMessage(Commands_1.PrivateMessage, function (msg) {
            var _a;
            var _b = msg.params, target = _b.target, content = _b.content;
            var ctcpMessage = StringTools_1.decodeCtcp(content);
            var nick = (_a = msg.prefix) === null || _a === void 0 ? void 0 : _a.nick;
            if (ctcpMessage) {
                if (ctcpMessage.command === 'ACTION') {
                    _this.emit(_this.onAction, target, nick, ctcpMessage.params, msg);
                }
                else {
                    _this.emit(_this.onCtcp, target, nick, ctcpMessage.command, ctcpMessage.params, msg);
                }
            }
            else {
                _this.emit(_this.onPrivmsg, target, nick, content, msg);
            }
        });
        _this.onTypedMessage(Commands_1.NickChange, function (msg) {
            var _a;
            var newNick = msg.params.nick;
            var oldNick = (_a = msg.prefix) === null || _a === void 0 ? void 0 : _a.nick;
            if (oldNick === _this._currentNick) {
                _this._currentNick = newNick;
            }
            _this.emit(_this.onNickChange, oldNick, newNick, msg);
        });
        _this.onTypedMessage(Commands_1.Notice, function (msg) {
            var _a;
            var _b = msg.params, target = _b.target, content = _b.content;
            var ctcpMessage = StringTools_1.decodeCtcp(content);
            var nick = (_a = msg.prefix) === null || _a === void 0 ? void 0 : _a.nick;
            if (ctcpMessage) {
                _this.emit(_this.onCtcpReply, target, nick, ctcpMessage.command, ctcpMessage.params, msg);
            }
            _this.emit(_this.onNotice, target, nick, content, msg);
        });
        _this.addInternalListener(_this.onRegister, function () { return _this._startPingCheckTimer(); });
        _this._credentials = tslib_1.__assign({}, credentials);
        if (channelTypes) {
            _this._serverProperties.channelTypes = channelTypes;
        }
        return _this;
    }
    IrcClient.prototype.receiveLine = function (line) {
        var _a;
        this._logger.debug("Received message: " + line);
        // eslint-disable-next-line @typescript-eslint/init-declarations
        var parsedMessage;
        try {
            parsedMessage = MessageParser_1.parseMessage(line, this._serverProperties, this._registeredMessageTypes, true, this._options.nonConformingCommands);
        }
        catch (e) {
            this._logger.error("Error parsing message: " + e.message);
            this._logger.trace((_a = e.stack) !== null && _a !== void 0 ? _a : 'No stack available');
            return;
        }
        this._logger.trace("Parsed message: " + JSON.stringify(parsedMessage));
        this._startPingCheckTimer();
        this.emit(this.onAnyMessage, parsedMessage);
        this._handleEvents(parsedMessage);
    };
    Object.defineProperty(IrcClient.prototype, "serverProperties", {
        get: function () {
            return json_1.klona(this._serverProperties);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IrcClient.prototype, "port", {
        get: function () {
            var _a = this._options, webSocket = _a.webSocket, _b = _a.connection, port = _b.port, secure = _b.secure;
            if (port) {
                return port;
            }
            if (webSocket) {
                return secure ? 443 : 80;
            }
            return secure ? 6697 : 6667;
        },
        enumerable: false,
        configurable: true
    });
    IrcClient.prototype.pingCheck = function () {
        var _this = this;
        var now = Date.now();
        var nowStr = now.toString();
        var handler = this.onTypedMessage(Commands_1.Pong, function (msg) {
            var message = msg.params.message;
            if (message === nowStr) {
                _this._logger.debug("Current ping: " + (Date.now() - now) + "ms");
                if (_this._pingTimeoutTimer) {
                    clearTimeout(_this._pingTimeoutTimer);
                }
                _this.removeMessageListener(handler);
            }
        });
        this._pingTimeoutTimer = setTimeout(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.removeMessageListener(handler);
                // eslint-disable-next-line no-restricted-syntax
                if (this._options.connection.reconnect === false) {
                    this._logger.error("Disconnecting because the last ping took over " + this._pingTimeout + " seconds");
                }
                else {
                    this._logger.warn("Reconnecting because the last ping took over " + this._pingTimeout + " seconds");
                }
                this._connection.assumeExternalDisconnect();
                return [2 /*return*/];
            });
        }); }, this._pingTimeout * 1000);
        this.sendMessage(Commands_1.Ping, { message: nowStr });
    };
    IrcClient.prototype.reconnect = function (message) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.quit(message)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.connect()];
                }
            });
        });
    };
    IrcClient.prototype.registerMessageType = function (cls) {
        if (cls.COMMAND !== '') {
            this._logger.trace("Registering message type " + cls.COMMAND);
            this._registeredMessageTypes.set(cls.COMMAND.toUpperCase(), cls);
        }
    };
    IrcClient.prototype.knowsCommand = function (command) {
        return this._registeredMessageTypes.has(command.toUpperCase());
    };
    IrcClient.prototype.getCommandClass = function (command) {
        return this._registeredMessageTypes.get(command.toUpperCase());
    };
    IrcClient.prototype.connect = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._supportsCapabilities = false;
                        this._negotiatedCapabilities = new Map();
                        this._currentNick = this._credentials.nick;
                        this._setupConnection();
                        this._logger.info("Connecting to " + this._connection.host + ":" + this._connection.port);
                        return [4 /*yield*/, this._connection.connect()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    IrcClient.prototype.addCapability = function (cap) {
        var e_5, _a;
        this._clientCapabilities.set(cap.name, cap);
        if (cap.messageTypes) {
            try {
                for (var _b = tslib_1.__values(Object.values(cap.messageTypes)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var messageType = _c.value;
                    this.registerMessageType(messageType);
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_5) throw e_5.error; }
            }
        }
    };
    IrcClient.prototype.registerCapability = function (cap) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.addCapability(cap);
                if (this._serverCapabilities.has(cap.name)) {
                    return [2 /*return*/, this._negotiateCapabilities([cap])];
                }
                return [2 /*return*/, []];
            });
        });
    };
    IrcClient.prototype.send = function (message) {
        this.sendRaw(message.toString());
    };
    IrcClient.prototype.sendRaw = function (line) {
        if (this._connection.isConnected) {
            this._logger.debug("Sending message: " + line);
            this._connection.sendLine(line);
        }
    };
    IrcClient.prototype.onNamedMessage = function (commandName, handler, handlerName) {
        if (!this._events.has(commandName)) {
            this._events.set(commandName, new Map());
        }
        var handlerList = this._events.get(commandName);
        if (!handlerName) {
            do {
                handlerName = commandName + ":" + shared_utils_1.padLeft(Math.random() * 10000, 4, '0');
            } while (handlerList.has(handlerName));
        }
        handlerList.set(handlerName, handler);
        return handlerName;
    };
    IrcClient.prototype.onTypedMessage = function (type, handler, handlerName) {
        return this.onNamedMessage(type.COMMAND, handler, handlerName);
    };
    IrcClient.prototype.removeMessageListener = function (handlerName) {
        var _a = tslib_1.__read(handlerName.split(':'), 1), commandName = _a[0];
        if (!this._events.has(commandName)) {
            return;
        }
        this._events.get(commandName).delete(handlerName);
    };
    IrcClient.prototype.createMessage = function (type, params, tags) {
        var tagsMap = tags ? new Map(Object.entries(tags)) : undefined;
        return Message_1.createMessage(type, params, undefined, tagsMap, this.serverProperties);
    };
    IrcClient.prototype.sendMessage = function (type, params, tags) {
        this.send(this.createMessage(type, params, tags));
    };
    IrcClient.prototype.sendMessageAndCaptureReply = function (type, params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var message, promise;
            return tslib_1.__generator(this, function (_a) {
                if (!type.SUPPORTS_CAPTURE) {
                    throw new Error("The command \"" + type.COMMAND + "\" does not support reply capture");
                }
                message = this.createMessage(type, params);
                promise = this.collect(message).promise();
                this.send(message);
                return [2 /*return*/, promise];
            });
        });
    };
    Object.defineProperty(IrcClient.prototype, "isConnected", {
        get: function () {
            return this._connection.isConnected;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IrcClient.prototype, "isConnecting", {
        get: function () {
            return this._connection.isConnecting;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IrcClient.prototype, "isRegistered", {
        get: function () {
            return this._registered;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IrcClient.prototype, "currentNick", {
        get: function () {
            return this._currentNick;
        },
        enumerable: false,
        configurable: true
    });
    /** @private */
    IrcClient.prototype.collect = function (originalMessage) {
        var types = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            types[_i - 1] = arguments[_i];
        }
        var collector = new (MessageCollector_1.MessageCollector.bind.apply(MessageCollector_1.MessageCollector, tslib_1.__spreadArray([void 0, this, originalMessage], tslib_1.__read(types))))();
        this._collectors.push(collector);
        return collector;
    };
    /** @private */
    IrcClient.prototype.stopCollect = function (collector) {
        this._collectors.splice(this._collectors.findIndex(function (value) { return value === collector; }), 1);
    };
    // convenience methods
    IrcClient.prototype.join = function (channel, key) {
        this.sendMessage(Commands_1.ChannelJoin, { channel: channel, key: key });
    };
    IrcClient.prototype.part = function (channel) {
        this.sendMessage(Commands_1.ChannelPart, { channel: channel });
    };
    IrcClient.prototype.quit = function (message) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.sendMessage(Commands_1.ClientQuit, { message: message });
                void this._connection.disconnect().then(function () {
                    _this._logger.debug('Finished cleaning up old connection');
                });
                return [2 /*return*/];
            });
        });
    };
    IrcClient.prototype.say = function (target, message, tags) {
        if (tags === void 0) { tags = {}; }
        this.sendMessage(Commands_1.PrivateMessage, { target: target, content: message }, tags);
    };
    IrcClient.prototype.sendCtcp = function (target, type, message) {
        this.say(target, "\u0001" + type.toUpperCase() + " " + message + "\u0001");
    };
    IrcClient.prototype.action = function (target, message) {
        this.sendCtcp(target, 'ACTION', message);
    };
    IrcClient.prototype.getPassword = function (currentPassword) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, currentPassword];
            });
        });
    };
    IrcClient.prototype.registerCoreMessageTypes = function () {
        var _this = this;
        shared_utils_1.forEachObjectEntry(MessageTypes.Commands, function (type) {
            _this.registerMessageType(type);
        });
        shared_utils_1.forEachObjectEntry(MessageTypes.Numerics, function (type) {
            _this.registerMessageType(type);
        });
    };
    IrcClient.prototype._negotiateCapabilityBatch = function (capabilities) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, Promise.all(capabilities
                        .filter(function (list) { return list.length; })
                        .map(function (capList) { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
                        return [2 /*return*/, this._negotiateCapabilities(capList)];
                    }); }); }))];
            });
        });
    };
    IrcClient.prototype._negotiateCapabilities = function (capList) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var mappedCapList, messages, capReply, negotiatedCapNames, newNegotiatedCaps, newNegotiatedCaps_1, newNegotiatedCaps_1_1, newCap, mergedCap;
            var e_6, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        mappedCapList = shared_utils_1.arrayToObject(capList, function (cap) {
                            var _a;
                            return (_a = {},
                                _a[cap.name] = cap,
                                _a);
                        });
                        return [4 /*yield*/, this.sendMessageAndCaptureReply(Commands_1.CapabilityNegotiation, {
                                subCommand: 'REQ',
                                capabilities: capList.map(function (cap) { return cap.name; }).join(' ')
                            })];
                    case 1:
                        messages = _b.sent();
                        capReply = messages.shift();
                        if (!capReply) {
                            throw new Error('capability negotiation failed unexpectedly without any reply');
                        }
                        if (!(capReply instanceof Commands_1.CapabilityNegotiation)) {
                            throw new Error("capability negotiation failed unexpectedly with \"" + capReply.command + "\" command");
                        }
                        negotiatedCapNames = capReply.params.capabilities.split(' ').filter(function (c) { return c; });
                        if (capReply.params.subCommand === 'ACK') {
                            // filter is necessary because some networks seem to add trailing spaces...
                            this._logger.debug("Successfully negotiated capabilities: " + negotiatedCapNames.join(', '));
                            newNegotiatedCaps = negotiatedCapNames.map(function (capName) { return mappedCapList[capName]; });
                            try {
                                for (newNegotiatedCaps_1 = tslib_1.__values(newNegotiatedCaps), newNegotiatedCaps_1_1 = newNegotiatedCaps_1.next(); !newNegotiatedCaps_1_1.done; newNegotiatedCaps_1_1 = newNegotiatedCaps_1.next()) {
                                    newCap = newNegotiatedCaps_1_1.value;
                                    mergedCap = this._clientCapabilities.get(newCap.name);
                                    mergedCap.param = newCap.param;
                                    this._negotiatedCapabilities.set(mergedCap.name, mergedCap);
                                }
                            }
                            catch (e_6_1) { e_6 = { error: e_6_1 }; }
                            finally {
                                try {
                                    if (newNegotiatedCaps_1_1 && !newNegotiatedCaps_1_1.done && (_a = newNegotiatedCaps_1.return)) _a.call(newNegotiatedCaps_1);
                                }
                                finally { if (e_6) throw e_6.error; }
                            }
                            return [2 /*return*/, newNegotiatedCaps];
                        }
                        else {
                            this._logger.warn("Failed to negotiate capabilities: " + negotiatedCapNames.join(', '));
                            return [2 /*return*/, new Error('capabilities failed to negotiate')];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    IrcClient.prototype._updateCredentials = function (newCredentials) {
        this._credentials = tslib_1.__assign(tslib_1.__assign({}, this._credentials), newCredentials);
    };
    IrcClient.prototype._setupConnection = function () {
        var _this = this;
        if (this._initialConnectionSetupDone) {
            return;
        }
        this._connection.onConnect(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a, password, e_7;
            var _this = this;
            var _b, _c;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this._logger.info("Connection to server " + this._connection.host + ":" + this._connection.port + " established");
                        this.emit(this.onConnect);
                        this._logger.debug('Determining connection password');
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Promise.all([
                                this.getPassword(this._credentials.password),
                                this.sendMessageAndCaptureReply(Commands_1.CapabilityNegotiation, {
                                    subCommand: 'LS',
                                    version: '302'
                                })
                                    .then(function (capReply) {
                                    if (!capReply.length || !(capReply[0] instanceof Commands_1.CapabilityNegotiation)) {
                                        _this._logger.debug('Server does not support capabilities');
                                        return [];
                                    }
                                    _this._supportsCapabilities = true;
                                    var capLists = capReply.map(function (line) {
                                        return shared_utils_1.arrayToObject(line.params.capabilities.split(' '), function (part) {
                                            var _a;
                                            if (!part) {
                                                return {};
                                            }
                                            var _b = tslib_1.__read(shared_utils_1.splitWithLimit(part, '=', 2), 2), cap = _b[0], param = _b[1];
                                            return _a = {},
                                                _a[cap] = {
                                                    name: cap,
                                                    param: param || true
                                                },
                                                _a;
                                        });
                                    });
                                    _this._serverCapabilities = new Map(Object.entries(Object.assign.apply(Object, tslib_1.__spreadArray([{}], tslib_1.__read(capLists)))));
                                    _this._logger.debug("Capabilities supported by server: " + Array.from(_this._serverCapabilities.keys()).join(', '));
                                    var capabilitiesToNegotiate = capLists.map(function (list) {
                                        var capNames = Object.keys(list);
                                        return Array.from(_this._clientCapabilities.entries())
                                            .filter(function (_a) {
                                            var _b = tslib_1.__read(_a, 1), name = _b[0];
                                            return capNames.includes(name);
                                        })
                                            .map(function (_a) {
                                            var _b = tslib_1.__read(_a, 2), cap = _b[1];
                                            return cap;
                                        });
                                    });
                                    return _this._negotiateCapabilityBatch(capabilitiesToNegotiate);
                                })
                                    .then(function () {
                                    _this.sendMessage(Commands_1.CapabilityNegotiation, { subCommand: 'END' });
                                })
                            ])];
                    case 2:
                        _a = tslib_1.__read.apply(void 0, [_d.sent(), 1]), password = _a[0];
                        if (password && password !== this._credentials.password) {
                            this._updateCredentials({ password: password });
                        }
                        if (password) {
                            this.sendMessage(Commands_1.Password, { password: password });
                        }
                        this.sendMessage(Commands_1.NickChange, { nick: this._credentials.nick });
                        this.sendMessage(Commands_1.UserRegistration, {
                            user: (_b = this._credentials.userName) !== null && _b !== void 0 ? _b : this._credentials.nick,
                            mode: '8',
                            unused: '*',
                            realName: (_c = this._credentials.realName) !== null && _c !== void 0 ? _c : this._credentials.nick
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        e_7 = _d.sent();
                        this.emit(this.onPasswordError, e_7);
                        this.quit().catch(function () {
                            return _this._logger.debug("Error while disconnecting after password error: " + e_7.message);
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); });
        this._initialConnectionSetupDone = true;
        this._connection.onReceive(function (line) {
            _this.receiveLine(line);
        });
        this._connection.onDisconnect(function (manually, reason) {
            _this._registered = false;
            if (_this._pingCheckTimer) {
                clearTimeout(_this._pingCheckTimer);
            }
            if (_this._pingTimeoutTimer) {
                clearTimeout(_this._pingTimeoutTimer);
            }
            if (manually) {
                _this._logger.info('Disconnected');
            }
            else {
                if (reason) {
                    _this._logger.error("Disconnected unexpectedly: " + reason.message);
                }
                else {
                    _this._logger.error('Disconnected unexpectedly');
                }
            }
            _this.emit(_this.onDisconnect, manually, reason);
        });
        this._connection.onEnd(function (manually) {
            if (!manually) {
                _this._logger.info('No further retries will be made');
            }
        });
    };
    IrcClient.prototype._handleReceivedClientNick = function (me) {
        if (this._currentNick !== me) {
            if (this._currentNick !== '') {
                this._logger.warn("Mismatching nicks: passed " + this._currentNick + ", but you're actually " + me);
            }
            this._currentNick = me;
        }
    };
    // event helper
    IrcClient.prototype._handleEvents = function (message) {
        var e_8, _a;
        this._collectors.some(function (collector) { return collector.collect(message); });
        var handlers = this._events.get(message.constructor.COMMAND);
        if (!handlers) {
            return;
        }
        try {
            for (var _b = tslib_1.__values(handlers.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var handler = _c.value;
                handler(message);
            }
        }
        catch (e_8_1) { e_8 = { error: e_8_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_8) throw e_8.error; }
        }
    };
    IrcClient.prototype._startPingCheckTimer = function () {
        var _this = this;
        if (this._pingCheckTimer) {
            clearTimeout(this._pingCheckTimer);
        }
        if (this._connection.isConnected) {
            this._pingCheckTimer = setTimeout(function () { return _this.pingCheck(); }, this._pingOnInactivity * 1000);
        }
        else {
            this._pingCheckTimer = undefined;
        }
    };
    tslib_1.__decorate([
        shared_utils_1.Enumerable(false)
    ], IrcClient.prototype, "_options", void 0);
    tslib_1.__decorate([
        shared_utils_1.Enumerable(false)
    ], IrcClient.prototype, "_credentials", void 0);
    return IrcClient;
}(typed_event_emitter_1.EventEmitter));
exports.IrcClient = IrcClient;
